import { resolveUploadAssetUrl } from './resolveUploadAssetUrl';

/**
 * Space branding assets have an optional dark-mode variant.
 *
 * The dark slot is never required: a customer who uploads only a light logo keeps
 * exactly the behaviour they had before this feature existed, in both themes. Only
 * when they upload a dark variant does the asset start following the theme.
 */

/** Pick the raw (unresolved) branding URL for the active theme, falling back to light. */
export function pickBrandingVariant(lightUrl, darkUrl, isDark) {
  const light = typeof lightUrl === 'string' ? lightUrl.trim() : '';
  const dark = typeof darkUrl === 'string' ? darkUrl.trim() : '';
  if (isDark && dark) return dark;
  return light;
}

/**
 * Absolute URL of the space logo for the active theme ('' when none is set).
 * `space` is the published-space payload (logo_url / logo_dark_url).
 */
export function resolveSpaceLogoUrl(space, isDark) {
  const chosen = pickBrandingVariant(space?.logo_url, space?.logo_dark_url, isDark);
  return chosen ? resolveUploadAssetUrl(chosen) : '';
}

/** Absolute URL of the space favicon for the active theme ('' when none is set). */
export function resolveSpaceFaviconUrl(space, isDark) {
  const chosen = pickBrandingVariant(space?.favicon_url, space?.favicon_dark_url, isDark);
  return chosen ? resolveUploadAssetUrl(chosen) : '';
}
